import { Timeline } from "vis-timeline/esnext";
import { DataSet } from "vis-data/esnext";
import moment from "moment";
import state from "../state";
import EventsNavView from "./EventsNavView";
import { timelineEntry } from "./templates/timeline";

class EventsTimelineView {
  constructor() {
    this.dom = document.querySelector("#events-timeline");
    this.eventsNav = new EventsNavView();
    this.entries = new DataSet();
    this.groups = new DataSet();

    // this.dom.addEventListener("focusin", () => {
    //   this.kbd = document.addEventListener("keydown", ev => {
    //     console.log(ev.key);
    //     this.timeline.zoomIn(0.3);
    //   });
    // });
    //
    // this.dom.addEventListener("focusout", () => {
    //   document.removeEventListener("keydown", this.kbd);
    // });

    // TODO: this should be managed by the filter and pushed through
    // via the event handlers
    this.filter = {
      countries: new Set(),
      sectors: new Set(),
      categories: new Set(),
      interventions: new Set()
    }

    this.timeline = new Timeline(this.dom, this.entries, this.groups, {
      height: "100%",
      maxHeight: "100%",
      align: "left",
      orientation: "top",
      max: moment().add("20", "days"),
      min: "2019-11-01",
      start: "2020-01-01",
      end: "2020-03-03",
      zoomMin: 86400001 * 4.5,
      verticalScroll: true,
      template: timelineEntry
    });

    state.channel.subscribe("onGraphLoaded", graph => {
      this.graph = graph;
    });

    // Handle entries being clicked on the timeline
    this.timeline.on("select", properties => {
      if (properties.items.length > 0) {
        // Broadcast the selected entry
        state.channel.publish("onEntrySelected", properties.items[0]);
      } else {
        // When no entry is selected close the currently open entry
        state.channel.publish("onEntryClosed");
      }
    });

    // this.timeline.on("click", (ev) => {
    //   this.dom.focus();
    // });

    state.channel.subscribe("onZoomIn", () => {
      this.timeline.zoomIn(0.05, { animation: false });
    });

    state.channel.subscribe("onZoomOut", () => {
      this.timeline.zoomOut(0.05, { animation: false });
    });

    state.channel.subscribe("onMoveForward", () => {
      this.moveTimeline(-0.017);
    });

    state.channel.subscribe("onMoveBackward", () => {
      this.moveTimeline(0.017);
    });

    // Deselect entries on the timeline when an entry close event is detected
    state.channel.subscribe("onEntryClosed", () => {
      this.timeline.setSelection([]);
    });

    state.channel.subscribe("onCountrySelected", country => {
      this.filter.countries.add(country.id);

      this.groups.add({
        id: country.id,
        content: country.name,
        treeLevel: 1
      });

      this.updateAll();
    });

    state.channel.subscribe("onCountryRemoved", countryId => {
      this.filter.countries.delete(countryId);
      this.groups.remove(countryId);
      this.updateAll();
    });

    state.channel.subscribe("onSectorSelected", sector => {
      this.filter.sectors.add(sector.id);
      this.updateAll();
    });

    state.channel.subscribe("onSectorRemoved", sectorId => {
      this.filter.sectors.delete(sectorId);
      this.updateAll();
    });

    state.channel.subscribe("onInterventionSelected", intervention => {
      this.filter.interventions.add(intervention.id);
      this.updateAll();
    });

    state.channel.subscribe("onInterventionRemoved", interventionId => {
      this.filter.interventions.delete(interventionId);
      this.updateAll();
    });

    state.channel.subscribe("onCategorySelected", category => {
      this.filter.categories.add(category.id);
      this.updateAll();
    });

    state.channel.subscribe("onCategoryRemoved", categoryId => {
      this.filter.categories.delete(categoryId);
      this.updateAll();
    });

    state.channel.subscribe("onResizePanel", () => {
      if (state.panelLayout.isEventsMin()) {
        this.dom.parentNode.classList.add("panel-min");
        this.dom.parentNode.classList.remove("panel-max");
      } else if (state.panelLayout.isEventsMax()) {
        this.dom.parentNode.classList.add("panel-max");
        this.dom.parentNode.classList.remove("panel-min");
      } else {
        this.dom.parentNode.classList.remove("panel-max");
        this.dom.parentNode.classList.remove("panel-min");
      }
    });
  }

  moveTimeline(increment) {
    const { start, end } = this.timeline.getWindow();
    const delta = end - start;
    const moveStart = start.valueOf() - delta * increment;
    const moveEnd = end.valueOf() - delta * increment;

    this.timeline.setWindow(moveStart, moveEnd, { animation: false });
  }

  updateAll() {
    const entries = new DataSet();

    for (const countryId of [...this.filter.countries]) {
      this.updateCountry(entries, countryId);
    }

    this.timeline.setItems(entries);
  }

  updateCountry(entries, countryId) {
    const selectedEntries = this.graph.policiesFor(
      countryId,
      [...this.filter.sectors],
      [...this.filter.interventions],
      [...this.filter.categories]
    );

    const entriesBuffer = [];
    for (const entry of selectedEntries) {
      // vis-data requires us to clone any entries which appear in multiple
      // groups as they cannot be added more than once when referencing the
      // same id. This should go in a utility method.
      let entryId;
      if (entries.get(entry.id)) {
        const rng = new Uint32Array(1);
        const [rid] = window.crypto.getRandomValues(rng);
        entryId = rid;
      } else {
        entryId = entry.id;
      }

      entriesBuffer.push({
        id: entryId,
        content: entry.title,
        hasJustification: entry.justification ? true : false,
        start: entry.props.startDate,
        group: countryId,
        className: state.countryLabels.assigned(countryId)
      });
    }

    entries.add(entriesBuffer);
  }

  syncRangeChange(otherTimeline, callback) {
    this.timeline.on("rangechange", ev => {
      otherTimeline.setWindow(ev.start, ev.end);
      callback(this.timeline, otherTimeline.timeline);
    });
  }

  setWindow(start, end) {
    this.timeline.setWindow(start, end, { animation: false });
  }
}

export default EventsTimelineView;
